import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AxiosError } from 'axios';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Payroll, PayrollDetails } from '../../domain/Payroll/entities/types';

export type PayrollState = {
  payrollListData: Nullable<Payroll[]>;
  payrollDetailsData: Nullable<PayrollDetails>;
  selectedPayroll: Nullable<Payroll>;
  onResetSelectedPayroll: () => void;
  onSelectPayroll: (payrollId: number) => void;
  loadingState: {
    isLoadingPayrollListData: boolean;
    isLoadingPayrollDetails: boolean;
  };
  errorState: {
    payrollListDataError?: AxiosError<
      APIGatewayResponse<unknown>,
      { code: string; type: string; param: string; message: string }
    >;
    payrollDetailsError?: AxiosError<
      APIGatewayResponse<unknown>,
      { code: string; type: string; param: string; message: string }
    >;
  };
};

export enum PayrollContextActionTypes {
  SetSelectedPayroll = '@@PayrollFile/SET_SELECTED_PAYROLL',
  ResetSelectedPayroll = '@@PayrollFile/RESET_SELECTED_PAYROLL',
}
